// Define action types
export const SET_CREATE_INTENT_RESPONSE = 'SET_CREATE_INTENT_RESPONSE';

// Define action creators
export const setCreateIntentResponse = (response) => ({
  type: SET_CREATE_INTENT_RESPONSE,
  payload: response,
});
